import { FC, ReactNode } from 'react';
import { ToastsProvider } from '@brg/ui';
import { createGlobalStyle } from "styled-components";
import { useToastsPosition } from "../hooks/useToastPosition";
import { useToastsTheme } from 'core/hooks/useToastTheme';

interface PropsT {

}

const GlobalToastsStyle = createGlobalStyle`
  .react-toast-notifications__container {
    z-index: 200000 !important;
    bottom: 40px!important;

    div{
      overflow: hidden;
    }

    @media(max-width: 1280px) {
      bottom: 50px!important;
    }
    
    @media(max-width: 940px) {
      bottom: 40px!important;
    }
    
    @media(max-width: 744px) {
      bottom: 28px!important;
    }
    
    @media(max-width: 568px) {
      bottom: 0px!important;
    }

    @media(max-width: 520px) {
      max-height: 39% !important;
    }
    
    @media (max-width: 320px) {
      padding: 0 !important;
      max-height: 37% !important;
    }
  }
`

export const CustomToastsProvider: FC<PropsT & { children?: ReactNode }> = (props) => {
  return (
    <>
      <GlobalToastsStyle/>
      <ToastsProvider {...useToastsPosition('top-right')} {...useToastsTheme()}>
        {props.children}
      </ToastsProvider>
    </>
  )
};
import { FC, ReactNode } from 'react';
import { ToastsProvider } from '@brg/ui';
import { createGlobalStyle } from "styled-components";
import { useToastsPosition } from "../hooks/useToastPosition";
import { useToastsTheme } from 'core/hooks/useToastTheme';

interface PropsT {

}

const GlobalToastsStyle = createGlobalStyle`
  .react-toast-notifications__container {
    z-index: 200000 !important;
    bottom: 40px!important;

    div{
      overflow: hidden;
    }

    @media(max-width: 1280px) {
      bottom: 50px!important;
    }
    
    @media(max-width: 940px) {
      bottom: 40px!important;
    }
    
    @media(max-width: 744px) {
      bottom: 28px!important;
    }
    
    @media(max-width: 568px) {
      bottom: 0px!important;
    }

    @media(max-width: 520px) {
      max-height: 39% !important;
    }
    
    @media (max-width: 320px) {
      padding: 0 !important;
      max-height: 37% !important;
    }
  }
`

export const CustomToastsProvider: FC<PropsT & { children?: ReactNode }> = (props) => {
  return (
    <>
      <GlobalToastsStyle/>
      <ToastsProvider {...useToastsPosition('top-right')} {...useToastsTheme()}>
        {props.children}
      </ToastsProvider>
    </>
  )
};
